import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

// Sub-serializers for nested objects
const livestockSaleSerializeMap: SerializeMap<LoadsLivestockSale> = {
  id: "id",
  date: "date",
  title: "title",
  saleCode: "sale_code",
};

const buyerSerializeMap: SerializeMap<LoadsBuyer> = {
  id: "id",
  name: "name",
};

const destinationPropertySerializeMap: SerializeMap<LoadsDestinationProperty> =
  {
    PIC: "PIC",
    name: "name",
  };

const transportBusinessSerializeMap: SerializeMap<LoadsTransportBusiness> = {
  id: "id",
  name: "name",
};

const thirdPartySerializeMap: SerializeMap<LoadsThirdParty> = {
  id: "id",
  name: "name",
};

export const loadsSerializeMap: SerializeMap<Loads> = {
  id: "id",
  pickupDate: "pickup_date",
  status: "status",
  lastModified: "last_modified",
  created: "created",
  livestockSale: livestockSaleSerializeMap,
  buyer: buyerSerializeMap,
  thirdParty: thirdPartySerializeMap,
  buyerWay: "buyer_way",
  destinationProperty: destinationPropertySerializeMap,
  deliveryPen: "delivery_pen",
  quantity: "quantity",
  loadStatus: "load_status",
  saleLotStatus: "sale_lot_status",
  transportBusiness: transportBusinessSerializeMap,
  quantityDelivered: "quantity_delivered",
  quantityProgeny: "quantity_progeny",
  species: "species",
  sex: "sex",
  age: "age",
  breed: "breed",
  saleRound: "sale_round",
  saleyardName: "saleyard_name",
  marks: "marks",
  averageGrams: "average_grams",
  quantityWeighed: "quantity_weighed",
  totalMassGrams: "total_mass_grams",
};

const nestedObjectMap = {
  livestock_sale: "livestockSale",
  buyer: "buyer",
  destination_property: "destinationProperty",
  transport_business: "transportBusiness",
  third_party: "thirdParty",
};

export const serializeLoads = buildSerializer(
  loadsSerializeMap,
  "loads",
  nestedObjectMap,
);

export const deserializeLoads = buildDeserializer(
  loadsSerializeMap,
  "loads",
  nestedObjectMap,
);
